import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";

const LiveStreamHeaderSkeleton = () => {
  return (
    <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
      {/* Event name skeleton */}
      <Skeletons
        height={24}
        width={"300px"}
        style={{
          borderRadius: 6,
        }}
      />

      {/* Timer section skeleton */}
      <View style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
        {/* "Event will begin in:" text skeleton */}
        <Skeletons
          height={16}
          width={"120px"}
          style={{
            borderRadius: 4,
          }}
        />

        {/* Timer boxes skeleton */}
        <View style={{ flexDirection: "row", alignItems: "center", gap: 6 }}>
          {/* Hours */}
          <Skeletons
            height={32}
            width={"50px"}
            style={{
              borderRadius: 8,
            }}
          />
          {/* Colon */}
          <Skeletons
            height={16}
            width={"8px"}
            style={{
              borderRadius: 2,
            }}
          />
          {/* Minutes */}
          <Skeletons
            height={32}
            width={"50px"}
            style={{
              borderRadius: 8,
            }}
          />
          {/* Colon */}
          <Skeletons
            height={16}
            width={"8px"}
            style={{
              borderRadius: 2,
            }}
          />
          {/* Seconds */}
          <Skeletons
            height={32}
            width={"50px"}
            style={{
              borderRadius: 8,
            }}
          />
        </View>
      </View>
    </View>
  );
};

export default LiveStreamHeaderSkeleton;
